import {
  BANNER_DESKTOP_MEDIA,
  BANNER_DESKTOP_SIZES,
  BANNER_LCP_FORMAT,
  BANNER_MOBILE_MEDIA,
  BANNER_MOBILE_PRELOAD_TARGET_WIDTH,
  BANNER_MOBILE_SIZES,
} from 'constants/bannerImage'
import { getImageSrcSet, pickSrcFromSrcSet } from 'utils/bannerImageData'

export const getFirstBannerImage = (flexContent: any) => {
  if (!flexContent?.flex) {
    return null
  }

  const banner = flexContent.flex.find((section: any) => {
    if (!section.fieldGroupName?.includes('_Flex_Banner') || !section.image) {
      return false
    }

    const { childImageSharp } = section.image.localFile || {}

    return (
      childImageSharp?.mobile ||
      childImageSharp?.desktop ||
      childImageSharp?.gatsbyImageData
    )
  })

  return banner?.image ?? null
}

const buildPreloadLink = (
  imageData: any,
  media: string,
  sizes: string,
  targetWidth?: number
) => {
  const srcSet = getImageSrcSet(imageData, BANNER_LCP_FORMAT)

  if (!srcSet) {
    return null
  }

  const href =
    (targetWidth ? pickSrcFromSrcSet(srcSet, targetWidth) : null) ??
    pickSrcFromSrcSet(srcSet, 1200)

  if (!href) {
    return null
  }

  return {
    href,
    srcSet,
    sizes,
    media,
  }
}

export interface LcpPreloadLink {
  href: string
  srcSet?: string
  sizes?: string
  media?: string
}

export const getLcpPreloadLinks = (image: any): LcpPreloadLink[] => {
  const childImageSharp = image?.localFile?.childImageSharp
  const mobileData = childImageSharp?.mobile
  const desktopData = childImageSharp?.desktop
  const legacyData = childImageSharp?.gatsbyImageData

  if (mobileData && desktopData) {
    return [
      buildPreloadLink(
        mobileData,
        BANNER_MOBILE_MEDIA,
        BANNER_MOBILE_SIZES,
        BANNER_MOBILE_PRELOAD_TARGET_WIDTH
      ),
      buildPreloadLink(desktopData, BANNER_DESKTOP_MEDIA, BANNER_DESKTOP_SIZES),
    ].filter(Boolean) as LcpPreloadLink[]
  }

  if (!legacyData) {
    return []
  }

  const link = buildPreloadLink(
    legacyData,
    BANNER_MOBILE_MEDIA,
    BANNER_MOBILE_SIZES,
    BANNER_MOBILE_PRELOAD_TARGET_WIDTH
  )

  return link ? [link] : []
}

export const getLcpPreloadData = (
  image: any
): { href: string; srcSet?: string; sizes?: string } | null => {
  const links = getLcpPreloadLinks(image)

  return links[0] ?? null
}
